import React from 'react';
import cn from '@/utils/cn';
import { StatusType } from '../types';
import { STATUS_INFO, StatusIndicatorIcon } from './Rows/StatusIndicator';

const LEGEND_STATUSES: StatusType[] = ['submitted', 'inProgress', 'lowScore', 'notAssigned'];

const Legend = () => (
  <div
    className={cn(
      'tw-flex tw-ml-[12.75rem] tw-h-12',
      'tw-border tw-border-solid tw-border-med-grey tw-border-t-0',
    )}
  >
    <div className="tw-flex tw-ml-4">
      {LEGEND_STATUSES.map(status => (
        <div
          key={`legend-${status}`}
          className="tw-flex tw-items-center tw-w-[6.5rem]"
        >
          <StatusIndicatorIcon type={status} />
          <span className="tw-ml-2">{STATUS_INFO[status].label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default Legend;
